import React, { useRef, useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  Typography,
  Checkbox,
  Divider,
  FormControlLabel,
  FormHelperText,
  Button, Radio, RadioGroup
} from "@mui/material";
import swal from "sweetalert";
import { api_path } from "../../shared.js";
import { useSearchParams } from "react-router-dom";

export default function AgentRegisterForm() {
  const [searchParams] = useSearchParams();
  const job_id = searchParams.get("id");
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  // [FIX] default date เป็นวันที่ปัจจุบัน
  const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    date: today,
  });

  const [approvalStatus, setApprovalStatus] = useState(0); // ✅ เพิ่ม: ใช้เช็ค permission การกรอก CodeNo

  const [errors, setErrors] = useState({
    roles:          false,
    regions:        false,
    businessType:   false,
    alliance:       false,
    financial:      false,
    COMPANY_PROFILE:  "",
    AGENCY_AGREEMENT: "",
  });

  // [FIX] default ตัวเลือกแรกของทุกกลุ่ม
  const [selected, setSelected] = useState({
    roles:        "agent",        // Radio — ตัวเลือกแรก
    regions:      ["Asia"],       // Checkbox — ตัวเลือกแรก
    businessType: ["Sea Export"], // Checkbox — ตัวเลือกแรก
    alliance:     ["WCA"],        // Checkbox — ตัวเลือกแรก
    financial:    ["receipt"],    // Checkbox — ตัวเลือกแรก
  });

  const fieldRefs = useRef({});

  // ── Fetch existing agent (ตอนเปิดหน้า edit) ──
  useEffect(() => {
    if (!job_id) return;

    const fetchAgent = async () => {
      try {
        const res = await fetch(`${api_path}/customer/get-AgentRegistration.php?id=${job_id}`);
        const result = await res.json();

        if (!result || !result.data) {
          console.warn("ไม่พบข้อมูล agent:", result);
          return;
        }

        const data = result.data;

        setApprovalStatus(Number(data.approval_status) || 0); // ✅ เก็บ approval_status

        setFormData((prev) => ({
          ...prev,
          date:          data.requestInfo?.create_date || today,
          codeNo:        data.requestInfo?.codeNo || "",
          name:          data.basicInfo?.name || "",
          address:       data.basicInfo?.address || "",
          district:      data.basicInfo?.district || "",
          subdistrict:   data.basicInfo?.subdistrict || "",
          city:          data.basicInfo?.city || "",
          postalCode:    data.basicInfo?.postalCode || "",
          country:       data.basicInfo?.country || "",
          email:         data.basicInfo?.email || "",
          tel:           data.basicInfo?.tel || "",
          contactPerson: data.basicInfo?.contactPerson || "",
          otherBusiness: data.businessType?.other || "",
          otherAlliance: data.alliance?.other || "",
          membership:    data.alliance?.membership || "",
          creditTerm:    data.financial?.creditTerm || "",
          creditLimit:   data.financial?.creditLimit || "",
        }));

        // ✅ map regions / businessType / alliance / financial กลับเข้า selected[]
        const businessTypeList = [
          ...(data.businessType?.seaExport ? ["Sea Export"] : []),
          ...(data.businessType?.seaImport ? ["Sea Import"] : []),
          ...(data.businessType?.airExport ? ["Air Export"] : []),
          ...(data.businessType?.other ? ["Others"] : []),
        ];

        const allianceList = [
          ...(data.alliance?.WCA ? ["WCA"] : []),
          ...(data.alliance?.PPL ? ["PPL"] : []),
          ...(data.alliance?.X2  ? ["X2"]  : []),
        ];

        const financialList = data.financial?.type === "Receipt" ? ["receipt"] : ["payment"];

        // หา roles จาก profileType (เลือกตัวแรกที่เป็น true)
        let roleValue = selected.roles;
        if (data.profileType) {
          if (data.profileType.agent)     roleValue = "agent";
          else if (data.profileType.consignee) roleValue = "consignee";
          else if (data.profileType.notify)    roleValue = "notify";
          else if (data.profileType.shipper)   roleValue = "shipper";
        }

        setSelected((prev) => ({
          ...prev,
          roles:        roleValue,
          regions:      data.regions && data.regions.length > 0 ? data.regions : prev.regions,
          businessType: businessTypeList.length > 0 ? businessTypeList : prev.businessType,
          alliance:     allianceList.length > 0 ? allianceList : prev.alliance,
          financial:    financialList,
        }));

        // ✅ map ไฟล์เดิมกลับเข้า files[]
        if (result.files) {
          const mapFiles = (arr) => (arr || []).map((f) => ({ ...f, name: f.file_name }));
          setFiles({
            COMPANY_PROFILE:  mapFiles(result.files.COMPANY_PROFILE),
            AGENCY_AGREEMENT: mapFiles(result.files.AGENCY_AGREEMENT),
          });
        }
      } catch (error) {
        console.error("โหลดข้อมูล Agent ไม่สำเร็จ", error);
      }
    };

    fetchAgent();
  }, [job_id]);

  const handleRadioChange = (groupKey, value) => {
    setSelected((prev) => ({ ...prev, [groupKey]: value }));
    setErrors((prev) => ({ ...prev, [groupKey]: false }));
  };

  const handleCheckboxChange = (groupKey, event) => {
    const { name, checked } = event.target;
    setSelected((prev) => ({
      ...prev,
      [groupKey]: checked
        ? [...prev[groupKey], name]
        : prev[groupKey].filter((v) => v !== name),
    }));
    if (checked) {
      setErrors((prev) => ({ ...prev, [groupKey]: false }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const buildPayload = () => ({
    id: job_id || null,
    userId: localStorage.getItem("USER_ID") || null,
    requestInfo: {
      date:   formData.date,
      codeNo: formData.codeNo,
    },
    profileType: selected.roles,
    basicInfo: {
      name:          formData.name,
      address:       formData.address,
      district:      formData.district,
      subdistrict:   formData.subdistrict,
      city:          formData.city,
      postalCode:    formData.postalCode,
      country:       formData.country,
      email:         formData.email,
      tel:           formData.tel,
      contactPerson: formData.contactPerson,
    },
    regions: selected.regions,
    businessType: {
      seaExport: selected.businessType.includes("Sea Export"),
      seaImport: selected.businessType.includes("Sea Import"),
      airExport: selected.businessType.includes("Air Export"),
      others:    selected.businessType.includes("Others"),
      other:     formData.otherBusiness,
    },
    alliance: {
      WCA:        selected.alliance.includes("WCA"),
      PPL:        selected.alliance.includes("PPL"),
      X2:         selected.alliance.includes("X2"),
      other:      formData.otherAlliance,
      membership: formData.membership,
    },
    financial: {
      creditTerm:  Number(formData.creditTerm)  || 0,
      creditLimit: Number(formData.creditLimit) || 0,
      type: selected.financial.includes("both")
        ? "BOTH"
        : selected.financial.includes("receipt")
          ? "RECEIPT"
          : selected.financial.includes("payment")
            ? "PAYMENT"
            : null,
    },
    create_by: getUserID,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      roles:        selected.roles === "",
      regions:      selected.regions.length === 0,
      businessType: selected.businessType.length === 0,
      alliance:     selected.alliance.length === 0,
      financial:    selected.financial.length === 0,
      COMPANY_PROFILE:  files.COMPANY_PROFILE.length === 0  ? "Please upload this document" : "",

    };

    setErrors(newErrors);

    const hasError = Object.values(newErrors).some((v) => v);
    if (hasError) {
      const firstErrorKey = Object.keys(newErrors).find((k) => newErrors[k]);
      if (firstErrorKey && fieldRefs.current[firstErrorKey]) {
        fieldRefs.current[firstErrorKey].scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    try {
      const payload = new FormData();
      payload.append("data", JSON.stringify(buildPayload()));
      Object.keys(files).forEach((key) => {
        files[key].forEach((file) => payload.append(key, file));
      });

      const response = await fetch(`${api_path}/customer/agentRegistration.php`, {
        method: "POST",
        body:   payload,
      });
      const result = await response.json();

      if (response.ok && result.status) {
        swal("Done.", "Save data successfully", "success", { buttons: true, timer: 5000 })
          .then(() => {
            window.location = `./CustomerRegisterDetail?id=${result.id}&type=2`;
          });
      } else {
        alert("เกิดข้อผิดพลาด: " + result.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      alert("ไม่สามารถเชื่อมต่อ API ได้");
    }
  };

  const [files, setFiles] = useState({
    COMPANY_PROFILE:  [],
    AGENCY_AGREEMENT: [],
  });

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prev) => ({
      ...prev,
      [name]: [...prev[name], ...Array.from(selectedFiles)],
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleRemoveFile = async (docType, index) => {
    const file = files[docType][index];
    if (!window.confirm("ต้องการลบไฟล์นี้ใช่ไหม?")) return;
    if (file.id) {
      try {
        await fetch(`${api_path}/customer/delete-customer-file.php`, {
          method:  "POST",
          headers: { "Content-Type": "application/json" },
          body:    JSON.stringify({ id: file.id, file_path: file.file_path }),
        });
      } catch (error) {
        console.error("ลบไฟล์ไม่สำเร็จ", error);
      }
    }
    setFiles((prev) => {
      const updated = [...prev[docType]];
      updated.splice(index, 1);
      return { ...prev, [docType]: updated };
    });
  };

 const FILE_BASE_URL = `${api_path}/`;
 const getFileUrl    = (file) => FILE_BASE_URL + file.file_path;
 const renderUpload = (name, label, required = false) => (
      <Grid
        item xs={12}
        ref={(el) => (fieldRefs.current[name] = el)}
        sx={{
          border: "1px dashed",
          borderColor: errors[name] ? "#d32f2f" : "#ccc",
          borderRadius: 2,
          p: 2, mb: 2,
          bgcolor: errors[name] ? "#fff5f5" : "#fff",
        }}
      >
        <Typography variant="h6">
          {label}
          {required && <span style={{ color: "red" }}>*</span>}
        </Typography>
        <input type="file" multiple name={name} onChange={handleFileChange} style={{ margin: "10px 0" }} />
        {files[name].map((file, index) => (
          <Box key={index} display="flex" alignItems="center" gap={1}>
            <a href={getFileUrl(file)} target="_blank" rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}>
              {file.name || file.file_name}
            </a>
            <Button size="small" color="error" onClick={() => handleRemoveFile(name, index)}>ลบ</Button>
          </Box>
        ))}
        {errors[name] && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>{errors[name]}</Typography>
        )}
      </Grid>
    );
  // const renderUpload = (name, label) => (
  //   <Grid
  //     item xs={12}
  //     ref={(el) => (fieldRefs.current[name] = el)}
  //     sx={{
  //       border:       "1px dashed",
  //       borderColor:  errors[name] ? "#d32f2f" : "#ccc",
  //       borderRadius: 2,
  //       p: 2, mb: 2,
  //       bgcolor: errors[name] ? "#fff5f5" : "#fff",
  //     }}
  //   >
  //     <Typography variant="h6">
  //       {label}<span style={{ color: "red" }}>*</span>
  //     </Typography>
  //     <input type="file" multiple name={name} onChange={handleFileChange} style={{ margin: "10px 0" }} />
  //     {files[name].map((file, index) => (
  //       <Box key={index} display="flex" alignItems="center" gap={1}>
  //         <a href={getFileUrl(file)} target="_blank" rel="noopener noreferrer"
  //           style={{ color: "#1976d2", textDecoration: "underline" }}>
  //           {file.name || file.file_name}
  //         </a>
  //         <Button size="small" color="error" onClick={() => handleRemoveFile(name, index)}>ลบ</Button>
  //       </Box>
  //     ))}
  //     {errors[name] && (
  //       <Typography color="error" variant="body2" sx={{ mt: 1 }}>{errors[name]}</Typography>
  //     )}
  //   </Grid>
  // );

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label className="head">Account Registration Form (Oversea Customer)</label>
          </Grid>
        </Grid>
        <br />

        <Grid container spacing={2}>
          {/* [FIX] defaultValue={today} + value={formData.date} */}
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Request Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              name="date"
              value={formData.date || today}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Customer Code"
              name="codeNo"
              value={formData.codeNo || ""}
              onChange={handleChange}
              disabled={approvalStatus < 6} // ✅ disable ถ้า approval_status ยังไม่ถึง 6
            />
          </Grid>
        </Grid>

        {/* Profile Type */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
          Profile Type <span style={{ color: "red" }}>*</span>
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <div ref={(el) => (fieldRefs.current["roles"] = el)}>
          {/* [FIX] value={selected.roles} → default "agent" */}
          <RadioGroup row value={selected.roles} onChange={(e) => handleRadioChange("roles", e.target.value)}>
            {[
              { name: "agent",     label: "Agent" },
              { name: "consignee", label: "Consignee" },
              { name: "notify",    label: "Notify" },
              { name: "shipper",   label: "Shipper" },
            ].map(({ name, label }) => (
              <FormControlLabel key={name} value={name} control={<Radio />} label={label} sx={{ width: "20%" }} />
            ))}
          </RadioGroup>
          {errors.roles && (
            <FormHelperText error sx={{ ml: 1 }}>Please select at least one profile type</FormHelperText>
          )}
        </div>

        {/* Basic Information */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>Basic Information</Typography>
        <Divider sx={{ mb: 3 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField fullWidth label="Agent / Consignee Name" name="name" required
              value={formData.name || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="Address" name="address" required
              value={formData.address || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label="District" name="district" required
              value={formData.district || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={3}>
            <TextField fullWidth label="Sub-District" name="subdistrict" required
              value={formData.subdistrict || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="City" name="city" required
              value={formData.city || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Postal Code" name="postalCode" required
              value={formData.postalCode || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Country" name="country" required
              value={formData.country || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Email" name="email"
              value={formData.email || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Tel" name="tel"
              value={formData.tel || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Contact Person" name="contactPerson"
              value={formData.contactPerson || ""} onChange={handleChange} />
          </Grid>
        </Grid>

        {/* Regions */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
          Regions <span style={{ color: "red" }}>*</span>
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <div ref={(el) => (fieldRefs.current["regions"] = el)}>
          {/* [FIX] default "Asia" checked */}
          <Grid container>
            {[
              "Asia", "Indian Sub", "Middle East", "Oceania", "Africa",
              "Europe", "Mediterranean", "North America", "Latin America",
            ].map((r) => (
              <Grid item xs={4} key={r}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={r}
                      checked={selected.regions.includes(r)}
                      onChange={(e) => handleCheckboxChange("regions", e)}
                    />
                  }
                  label={r}
                  sx={{ width: "100%" }}
                />
              </Grid>
            ))}
          </Grid>
          {errors.regions && (
            <FormHelperText error sx={{ ml: 1 }}>Please select at least one region</FormHelperText>
          )}
        </div>

        {/* Business Type */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
          Type of Business (Please tick the services engaged with this party){" "}
          <span style={{ color: "red" }}>*</span>
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <div ref={(el) => (fieldRefs.current["businessType"] = el)}>
          {/* [FIX] default "Sea Export" checked */}
          <Grid container>
            {["Sea Export", "Sea Import", "Air Export", "Others"].map((b) => (
              <Grid item xs={2} key={b}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={b}
                      checked={selected.businessType.includes(b)}
                      onChange={(e) => handleCheckboxChange("businessType", e)}
                    />
                  }
                  label={b}
                />
              </Grid>
            ))}
            <Grid item xs={3}>
              <TextField fullWidth label="Other" name="otherBusiness"
                value={formData.otherBusiness || ""} onChange={handleChange} />
            </Grid>
          </Grid>
          {errors.businessType && (
            <FormHelperText error sx={{ ml: 1 }}>Please select at least one business type</FormHelperText>
          )}
        </div>

        {/* Alliance */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
          Global Alliance / Network <span style={{ color: "red" }}>*</span>
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <div ref={(el) => (fieldRefs.current["alliance"] = el)}>
          {/* [FIX] default "WCA" checked */}
          <Grid container spacing={2}>
            {["WCA", "PPL", "X2"].map((a) => (
              <Grid item xs={3} key={a}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={a}
                      checked={selected.alliance.includes(a)}
                      onChange={(e) => handleCheckboxChange("alliance", e)}
                    />
                  }
                  label={a}
                />
              </Grid>
            ))}
            <Grid item xs={3}>
              <TextField fullWidth label="Other" name="otherAlliance"
                value={formData.otherAlliance || ""} onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Membership No" name="membership"
                value={formData.membership || ""} onChange={handleChange} />
            </Grid>
          </Grid>
          {errors.alliance && (
            <FormHelperText error sx={{ ml: 1 }}>Please select at least one alliance</FormHelperText>
          )}
        </div>

        {/* Financial */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>Financial Details</Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField fullWidth label="Credit Term (Days)" name="creditTerm"
              value={formData.creditTerm || ""} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Credit Limit (USD)" name="creditLimit"
              value={formData.creditLimit || ""} onChange={handleChange} />
          </Grid>
        </Grid>

        <div ref={(el) => (fieldRefs.current["financial"] = el)}>
          {/* [FIX] default "receipt" checked */}
          <Grid container sx={{ mt: 2 }}>
            {[
              { name: "receipt", label: "Receipt (This party pays us)" },
              { name: "payment", label: "Payment (We pay for this party)" },
              { name: "both",    label: "Receipt & Payment" },
            ].map(({ name, label }) => (
              <Grid item xs={4} key={name}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name={name}
                      checked={selected.financial.includes(name)}
                      onChange={(e) => handleCheckboxChange("financial", e)}
                    />
                  }
                  label={label}
                  sx={{ width: "100%" }}
                />
              </Grid>
            ))}
          </Grid>
          {errors.financial && (
            <FormHelperText error sx={{ ml: 1 }}>Please select at least one financial option</FormHelperText>
          )}
        </div>

        {/* Documents */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>Required Documents</Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {renderUpload("COMPANY_PROFILE",  "Business Registration Certificate (or Company Profile)",true)}
            {renderUpload("AGENCY_AGREEMENT", "Agency Agreement (if applicable)")}
          </Grid>
        </Grid>

        <Grid container sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">Submit</Button>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}